import { render, staticRenderFns } from "./ExtensionsDetail.vue?vue&type=template&id=76fa327a"
import script from "./ExtensionsDetail.vue?vue&type=script&lang=ts"
export * from "./ExtensionsDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports